import {FETCH_RATE_CARD_VALUE, FETCH_RATE_CARD_VALUE_SUCCESS, FETCH_RATE_CARD_VALUE_ERROR, UPDATE_RATE_CARD_VALUE, UPDATE_RATE_CARD_VALUE_SUCCESS, UPDATE_RATE_CARD_VALUE_ERROR, RESET_UPDATE_RATE_CARD_VALUE} from "constants/ActionTypes";

export const fetchRateCardValue = () => {
  return {
    type: FETCH_RATE_CARD_VALUE,
  }
};

export const fetchRateCardValueSuccess = (rateCardList) => {
  return {
    type: FETCH_RATE_CARD_VALUE_SUCCESS,
    payload: rateCardList,
  }
};

export const fetchRateCardValueError = (error) => {
  return {
    type: FETCH_RATE_CARD_VALUE_ERROR,
    payload: error
  }
};

export const updateRateCardValue = (params) => {
  return {
    type: UPDATE_RATE_CARD_VALUE,
    params,
  }
};

export const updateRateCardValueSuccess = (payload) => {
  return {
    type: UPDATE_RATE_CARD_VALUE_SUCCESS,
    payload,
  }
};

export const updateRateCardValueError = (error) => {
  return {
    type: UPDATE_RATE_CARD_VALUE_ERROR,
    payload: error
  }
};

export const resetUpdateRateCardValue = () => {
  return {
    type: RESET_UPDATE_RATE_CARD_VALUE,
  }
};
